import { useEffect } from "react"
import config from "aldoo-ra/Config"
const { FACEBOOK_PIXEL, FACEBOOK_OPTIONS, TRACKING_GDPR } = config
import PubSub from "pubsub-js"
import { hasConsent, CONSENT_EVENT } from "./consent"

export default function FacebookTracking({ children }) {
  useEffect(() => {
    if (!FACEBOOK_PIXEL) return

    import("react-facebook-pixel")
      .then((x) => x.default)
      .then((ReactPixel) => {
        //This is initialized through GTM
        ReactPixel.init(FACEBOOK_PIXEL, undefined, FACEBOOK_OPTIONS)
        // Revoke before the first hit; the consent banner grants it later
        if (TRACKING_GDPR && !hasConsent()) ReactPixel.revokeConsent()
        ReactPixel.pageView()

        PubSub.subscribe(CONSENT_EVENT, (_, value) => {
          if (value === "granted") ReactPixel.grantConsent()
          else ReactPixel.revokeConsent()
        })

        PubSub.subscribe("Tracking_PageView", () => {
          ReactPixel.pageView()
        })

        PubSub.subscribe("Tracking_NewAccountCreated", () => {
          ReactPixel.track("CompleteRegistration")
        })

        PubSub.subscribe("Tracking_InitiateCheckout", (_, data) => {
          ReactPixel.track("InitiateCheckout", {
            price: data.price,
            currency: data.currency,
          })
        })

        PubSub.subscribe("Tracking_Subscribed", (_, data) => {
          ReactPixel.track("Subscribe", {
            price: data.price,
            currency: data.currency,
          })
        })

        PubSub.subscribe("Tracking_Purchase", (_, data) => {
          ReactPixel.track("Purchase", {
            price: data.price,
            currency: data.currency,
          })
        })
      })
  }, [])

  return children || null
}
